import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api/axios';
import { useCart } from '../context/CartContext';

const ProductDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addToCart, items, updateQty } = useCart();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const cartItem = items.find(i => i.id === id);

  useEffect(() => {
    api.get(`/products/${id}`)
      .then(({ data }) => setProduct(data.data))
      .catch(() => navigate('/'))
      .finally(() => setLoading(false));
  }, [id, navigate]);

  if (loading) return <div className="flex-center" style={{ height: 400 }}><div className="spinner"></div></div>;
  if (!product) return null;

  return (
    <div className="page" style={{ maxWidth: 900 }}>
      <button className="btn btn-light btn-sm" style={{ marginBottom: 24 }} onClick={() => navigate(-1)}>
        ← Back to products
      </button>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 40, alignItems: 'start' }}>
        {/* Image */}
        <div style={{ background: 'var(--green-pale)', borderRadius: 20, overflow: 'hidden', aspectRatio: '1', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {product.image_url ? (
            <img src={product.image_url} alt={product.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          ) : (
            <div style={{ fontSize: 96 }}>🥬</div>
          )}
        </div>

        {/* Details */}
        <div>
          <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--green)', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 8 }}>
            {product.category}
          </div>
          <h1 style={{ fontSize: 28, fontWeight: 900, marginBottom: 12 }}>{product.name}</h1>
          {product.description && (
            <p style={{ color: 'var(--text-3)', fontSize: 15, lineHeight: 1.7, marginBottom: 24 }}>{product.description}</p>
          )}
          <div style={{ fontSize: 36, fontWeight: 900, color: 'var(--green-dark)', marginBottom: 8 }}>
            ₹{parseFloat(product.price).toLocaleString('en-IN')}
          </div>
          <div style={{ fontSize: 13, color: 'var(--text-3)', marginBottom: 24 }}>
            {product.stock_quantity} units available
          </div>

          {product.status === 'out_of_stock' ? (
            <div className="out-of-stock-badge" style={{ fontSize: 15, padding: '12px 24px' }}>Out of Stock</div>
          ) : cartItem ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
              <div className="qty-control" style={{ padding: '8px 12px' }}>
                <button className="qty-btn" onClick={() => updateQty(product.id, cartItem.quantity - 1)}>−</button>
                <span className="qty-value" style={{ fontSize: 18 }}>{cartItem.quantity}</span>
                <button className="qty-btn" onClick={() => updateQty(product.id, cartItem.quantity + 1)}>+</button>
              </div>
              <button className="btn btn-green" onClick={() => navigate('/cart')}>View Cart →</button>
            </div>
          ) : (
            <button className="btn btn-green" style={{ fontSize: 16, padding: '14px 32px' }} onClick={() => addToCart(product)}>
              🛒 Add to Cart
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductDetailPage;
